import { config } from '@tamagui/config/v3';
import { createTamagui, createTokens } from '@tamagui/core';
import type { TamaguiInternalConfig } from '@tamagui/core';
import { COLORS } from './src/constants/colors';

// Создаём кастомные токены цветов
const tokens = createTokens({
  ...config.tokens,
  color: {
    ...config.tokens.color,
    // Основные цвета приложения
    primary: COLORS.PRIMARY,
    gradientStart: COLORS.LIGHT_GRADIENT_START,
    gradientEnd: COLORS.LIGHT_GRADIENT_END,

    // Цвета текста
    lightText: COLORS.LIGHT_TEXT,
    darkText: COLORS.DARK_TEXT,

    // Системные цвета
    success: COLORS.SUCCESS,
    error: COLORS.ERROR,
    warning: COLORS.WARNING,
    disabled: COLORS.DISABLED,

    // Базовые цвета
    white: COLORS.WHITE,
    black: COLORS.BLACK,
    transparent: COLORS.TRANSPARENT,

    // Фоны
    lightBackground: COLORS.LIGHT_BACKGROUND,
    darkBackground: COLORS.DARK_BACKGROUND,
    lightSurface: COLORS.LIGHT_SURFACE,
    darkSurface: COLORS.DARK_SURFACE,
  },
});

// Создаём кастомные темы
const lightTheme = {
  background: tokens.color.lightBackground,
  backgroundHover: tokens.color.lightSurface,
  backgroundPress: tokens.color.lightSurface,
  backgroundFocus: tokens.color.lightSurface,
  backgroundStrong: tokens.color.white,
  backgroundTransparent: tokens.color.transparent,

  color: tokens.color.darkText,
  colorHover: tokens.color.darkText,
  colorPress: tokens.color.darkText,
  colorFocus: tokens.color.darkText,
  colorTransparent: tokens.color.transparent,

  borderColor: tokens.color.disabled,
  borderColorHover: tokens.color.primary,
  borderColorPress: tokens.color.primary,
  borderColorFocus: tokens.color.primary,

  placeholderColor: tokens.color.disabled,

  // Кастомные цвета для приложения
  primary: tokens.color.primary,
  primaryText: tokens.color.lightText,
  gradientStart: tokens.color.gradientStart,
  gradientEnd: tokens.color.gradientEnd,

  success: tokens.color.success,
  error: tokens.color.error,
  warning: tokens.color.warning,

  fontFamily: 'Poppins',
  fontFamilyHeading: 'Poppins',
};

const darkTheme = {
  background: tokens.color.darkBackground,
  backgroundHover: tokens.color.darkSurface,
  backgroundPress: tokens.color.darkSurface,
  backgroundFocus: tokens.color.darkSurface,
  backgroundStrong: tokens.color.darkSurface,
  backgroundTransparent: tokens.color.transparent,

  color: tokens.color.lightText,
  colorHover: tokens.color.lightText,
  colorPress: tokens.color.lightText,
  colorFocus: tokens.color.lightText,
  colorTransparent: tokens.color.transparent,

  borderColor: tokens.color.disabled,
  borderColorHover: tokens.color.primary,
  borderColorPress: tokens.color.primary,
  borderColorFocus: tokens.color.primary,

  placeholderColor: tokens.color.disabled,

  primary: tokens.color.primary,
  primaryText: tokens.color.lightText,
  gradientStart: tokens.color.gradientStart,
  gradientEnd: tokens.color.gradientEnd,

  success: tokens.color.success,
  error: tokens.color.error,
  warning: tokens.color.warning,

  // Czcionka Poppins
  fontFamily: 'Poppins',
  fontFamilyHeading: 'Poppins',
};

const appConfig = createTamagui({
  ...config,
  tokens,
  themes: {
    ...config.themes,
    light: lightTheme,
    dark: darkTheme,
  },
} as any) as TamaguiInternalConfig;

export type AppConfig = typeof appConfig;

declare module '@tamagui/core' {
  interface TamaguiCustomConfig extends AppConfig {}
}

export default appConfig;
